import React from 'react'
import { Widget } from 'features/types'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { PreWorkWidgetLoadingGuard, TopicNotSelectedGuard } from '../../share/guards'
import StreamWidgetDataGuards from '../share/guards/StreamWidgetDataGuards'
import FingerprintRunSearchEffect from '../share/searches/FingerprintRunSearchEffect'
import Stream from '../share/Stream'
import SoundbiteRunSearchEffect from './SoundbiteRunSearchEffect'
import LoadMoreGuard from '../share/guards/LoadMoreGuard'
import WidgetSettingContext from '../share/widgetSettingContext'
import { useStreamWidgetLoadMoreInfo } from '../share/useStreamWidgetLoadMoreInfo'

const SocialWebStream: Widget = ({ widgetId }) => {
  const {
    loadMoreCursor,
    maxSoundbites,
    countType,
    handleLoadMore
  } = useStreamWidgetLoadMoreInfo<SocialWebStreamWidget>(widgetId)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <FingerprintRunSearchEffect widgetId={widgetId} countType={countType}>
          <PreWorkWidgetLoadingGuard widgetId={widgetId}>
            <StreamWidgetDataGuards widgetId={widgetId}>
              <SoundbiteRunSearchEffect widgetId={widgetId} fingerprintIndex={loadMoreCursor}>
                <LoadMoreGuard widgetId={widgetId}>
                  <WidgetSettingContext.Provider value={{ countType, maxSoundbites }}>
                    <Stream
                      widgetId={widgetId}
                      fingerprintIndex={loadMoreCursor}
                      callback={handleLoadMore}
                    />
                  </WidgetSettingContext.Provider>
                </LoadMoreGuard>
              </SoundbiteRunSearchEffect>
            </StreamWidgetDataGuards>
          </PreWorkWidgetLoadingGuard>
        </FingerprintRunSearchEffect>
      </TopicNotSelectedGuard>
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebStream
